import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import styles from './ConfirmDialog.module.css';
import styles_button from '../../../styles/Button.module.css';
import styles_grid from "../../../styles/Grid.module.css";
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

interface DialogNewPasswordProps {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  titleButtonConfirm?: string;
  titleButtonClose?: string;
  titleLoadButton?: string;
}

const ConfirmDialog: React.FC<DialogNewPasswordProps> = ({
  open,
  loading,
  onClose,
  onConfirm,
  title,
  message,
  titleButtonConfirm,
  titleButtonClose,
  titleLoadButton,
}) => {

  const handleClose = () => {
    onClose();
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className={styles.dialogTitle}>
          {title}
        </DialogTitle>
        <DialogContent className={styles.dialogContent}>
          <p className={styles.dialogText}>
            {message}
          </p>
        </DialogContent>
        <DialogActions className={styles_grid.displayFlexBetween}>
          <div className={styles_grid.flex1}>
            <Button 
              onClick={handleClose}
              className={styles_button.buttonOutlineDanger}
              startIcon={<CloseOutlinedIcon/>}
              disabled={loading} 
            >
              {titleButtonClose ?? 'Cancelar'}
            </Button>
          </div>

          <div className={`${styles_grid.flex1} ${styles_grid.justifyEnd}`}>
            <Button 
              onClick={onConfirm} 
              startIcon={<CheckOutlinedIcon/>} 
              className={`${styles_button.buttonPrimary} ${(loading) ? styles_button.buttonLoad : ''} `}
            >
              {loading ? (
                <>
                <div className={styles_button.spinner}></div>
                <span>{titleLoadButton ?? 'Confirmando...'}</span>
                </>
              ) : (
                <span>{titleButtonConfirm ?? 'Confirmar'}</span>
              )}
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ConfirmDialog;
